import { IUserSettings, IUserTutorialStatus } from "../helpers/types";

/**
 * Checks the visibility status of a modal by retrieving it from local storage
 * and optionally from an external API if the status is not already stored locally.
 *
 * @param modalKey - The unique key identifying the modal (e.g., "hasSeenProfileModal").
 * @param getStatus - A function to fetch the modal status from an external API.
 *                     Should return a promise resolving to an object containing a `value` boolean.
 * @param setModalVisibility - A function to update the visibility state of the modal.
 */
export const checkModalStatus = async (
  modalKey: keyof IUserTutorialStatus,
  setModalVisibility: (visible: boolean) => void,
  userSettings: IUserSettings | null
) => {
  if (!userSettings?.visibilityStatus) {
    console.warn("User visibility status not available");
    return;
  }

  const hasSeenModal = userSettings.visibilityStatus[modalKey];
  setModalVisibility(!hasSeenModal);
};
